import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

interface BaseNavigationItem {
    isExternalLink?: boolean;
    isFreeAccess?: boolean;
    isMenu: boolean;
    title?: string;
}

export interface NavigationLink extends BaseNavigationItem {
    Icon?: OverridableComponent<SvgIconTypeMap<Record<string, unknown>, 'svg'>>;
    // as is what is shown in the url - will be used with translation
    as?: string;
    // href is the internal url provided to the router
    href: string;
    isMenu: false;
}

export interface NavigationMenu extends BaseNavigationItem {
    isMenu: true;
    links: NavigationLink[];
}

export type NavigationItem = NavigationMenu | NavigationLink;

const getNavigationItems = (): NavigationItem[] => [
    {
        href: '/search/ai',
        isExternalLink: false,
        isFreeAccess: false,
        isMenu: false,
        title: 'vogelAi',
    },
    {
        href: '/books',
        isExternalLink: false,
        isFreeAccess: true,
        isMenu: false,
        title: 'books',
    },
    { href: '/search', isExternalLink: false, isFreeAccess: true, isMenu: false, title: 'search' },
    {
        href: '/search/tree-view',
        isExternalLink: false,
        isFreeAccess: false,
        isMenu: false,
        title: 'treeView',
    },
    {
        href: '/search/icicle',
        isExternalLink: false,
        isFreeAccess: false,
        isMenu: false,
        title: 'icicle',
    },
    {
        isExternalLink: false,
        isMenu: true,
        links: [
            {
                href: '/glossary',
                isExternalLink: false,
                isFreeAccess: false,
                isMenu: false,
                title: 'glossary',
            },
            {
                href: '/legal-charts',
                isExternalLink: false,
                isFreeAccess: false,
                isMenu: false,
                title: 'legalCharts',
            },
        ],
        title: 'legalTools',
    },
    {
        isExternalLink: false,
        isMenu: true,
        links: [
            {
                href: '/vogel-academy/register',
                isExternalLink: false,
                isFreeAccess: false,
                isMenu: false,
                title: 'vogelAcademyRegister',
            },
            {
                href: '/vogel-academy/replays',
                isExternalLink: false,
                isFreeAccess: false,
                isMenu: false,
                title: 'vogelAcademyReplays',
            },
        ],
        title: 'vogelAcademy',
    },
    {
        isExternalLink: false,
        isMenu: true,
        links: [
            {
                href: '/vogel-actu/livv-newsflash',
                isExternalLink: false,
                isFreeAccess: false,
                isMenu: false,
                title: 'vogelActuFiveInfos',
            },
            {
                href: '/vogel-actu/livv-newsletter',
                isExternalLink: false,
                isFreeAccess: false,
                isMenu: false,
                title: 'vogelActuCdcLetter',
            },
        ],
        title: 'vogelActu',
    },

    { href: '/profile', isMenu: false },
];

export default getNavigationItems;
